export const LIMIT = 25;
export const RESTAURANTS_UPDATE_SECTIONS = ['details'];
